import { render, staticRenderFns } from "./DashboardInvoiceCheck.vue?vue&type=template&id=b52fbf96&scoped=true&"
import script from "./DashboardInvoiceCheck.vue?vue&type=script&lang=js&"
export * from "./DashboardInvoiceCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52fbf96",
  null
  
)

export default component.exports